import { createFileRoute, redirect } from '@tanstack/react-router';
import { PortalShell } from '@/app/layouts/PortalShell';
import { isAuthenticatedSync, canEnterPortalSync } from '@/shared/lib/auth-state';

/**
 * Shell del portale clienti: autenticata come `_app`, ma senza nessuna delle sue letture
 * di contesto — che per un utente-cliente sarebbero tutte 403 (vedi `PortalShell`).
 */
export const Route = createFileRoute('/_portal')({
  beforeLoad: ({ location }) => {
    if (!isAuthenticatedSync()) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
    /* Simmetrico alla guardia di `_app`: un interno qui vedrebbe un portale che non gli
       appartiene, e le sue chiamate tornerebbero comunque vuote — il perimetro del
       server è il `Client` dell'account, e lui non ne ha uno.

       ⚠️ Si guarda `canEnterPortalSync` e non `isPortalSessionSync`: un **ibrido** (P8) parte nel
       gestionale ma il portale è suo, e deve poterci entrare con un gesto esplicito. Con la
       seconda funzione verrebbe rimbalzato fuori dal proprio portale. */
    if (!canEnterPortalSync()) {
      throw redirect({ to: '/', replace: true });
    }
  },
  component: PortalShell,
});
